module.exports = __webpack_public_path__ + "static/media/invite_register_bg@3x.a881b02c.png";